// This file was auto-generated by Fern from our API Definition.
import { normalizeClientOptionsWithAuth } from "../../../../BaseClient.js";
import { mergeHeaders } from "../../../../core/headers.js";
import * as core from "../../../../core/index.js";
import { toJson } from "../../../../core/json.js";
import * as environments from "../../../../environments.js";
import { handleNonStatusCodeError } from "../../../../errors/handleNonStatusCodeError.js";
import * as errors from "../../../../errors/index.js";
import * as AgentaApi from "../../../index.js";
/**
 * Workflow definitions — the runnable pipelines that back an application.
 */
export class WorkflowsClient {
    _options;
    constructor(options) {
        this._options = normalizeClientOptionsWithAuth(options);
    }
    /**
     * List the shared JSON Schema fragments available to workflow schemas.
     *
     * Workflow input/output schemas reference these via `x-ag-type-ref` (for
     * example, `message` or `prompt`). Use this endpoint to discover what
     * type keys exist before building a schema.
     *
     * See: [Workflows](/reference/api-guide/workflows).
     *
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @example
     *     await client.workflows.listWorkflowCatalogTypes()
     */
    listWorkflowCatalogTypes(requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__listWorkflowCatalogTypes(requestOptions));
    }
    async __listWorkflowCatalogTypes(requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "workflows/catalog/types/"),
            method: "GET",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return {
                data: _response.body,
                rawResponse: _response.rawResponse,
            };
        }
        if (_response.error.reason === "status-code") {
            throw new errors.AgentaApiError({
                statusCode: _response.error.statusCode,
                body: _response.error.body,
                rawResponse: _response.rawResponse,
            });
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "GET", "/workflows/catalog/types/");
    }
    /**
     * Return the JSON Schema for a single shared type key.
     *
     * Returns 404 when the `ag_type` is not part of the shipped catalog.
     *
     * See: [Workflows](/reference/api-guide/workflows).
     *
     * @param {AgentaApi.FetchWorkflowCatalogTypeRequest} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.workflows.fetchWorkflowCatalogType({
     *         ag_type: "ag_type"
     *     })
     */
    fetchWorkflowCatalogType(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__fetchWorkflowCatalogType(request, requestOptions));
    }
    async __fetchWorkflowCatalogType(request, requestOptions) {
        const { ag_type: agType } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `workflows/catalog/types/${core.url.encodePathParam(agType)}`),
            method: "GET",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return {
                data: _response.body,
                rawResponse: _response.rawResponse,
            };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "GET", "/workflows/catalog/types/{ag_type}");
    }
    /**
     * List the agent harness records shipped with the product.
     *
     * Each record carries the harness `capabilities` (providers, deployments, connection
     * modes, model selection, models). A workflow's harness field references one via
     * `x-ag-harness-ref`, resolved against `/catalog/harnesses/{ag_harness}`.
     *
     * See: [Workflows](/reference/api-guide/workflows).
     *
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @example
     *     await client.workflows.listWorkflowCatalogHarnesses()
     */
    listWorkflowCatalogHarnesses(requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__listWorkflowCatalogHarnesses(requestOptions));
    }
    async __listWorkflowCatalogHarnesses(requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "workflows/catalog/harnesses/"),
            method: "GET",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return {
                data: _response.body,
                rawResponse: _response.rawResponse,
            };
        }
        if (_response.error.reason === "status-code") {
            throw new errors.AgentaApiError({
                statusCode: _response.error.statusCode,
                body: _response.error.body,
                rawResponse: _response.rawResponse,
            });
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "GET", "/workflows/catalog/harnesses/");
    }
    /**
     * Return a single harness record (with its `capabilities`).
     *
     * Returns 404 when the `ag_harness` is not part of the shipped catalog.
     *
     * See: [Workflows](/reference/api-guide/workflows).
     *
     * @param {AgentaApi.FetchWorkflowCatalogHarnessRequest} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.workflows.fetchWorkflowCatalogHarness({
     *         ag_harness: "ag_harness"
     *     })
     */
    fetchWorkflowCatalogHarness(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__fetchWorkflowCatalogHarness(request, requestOptions));
    }
    async __fetchWorkflowCatalogHarness(request, requestOptions) {
        const { ag_harness: agHarness } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `workflows/catalog/harnesses/${core.url.encodePathParam(agHarness)}`),
            method: "GET",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return {
                data: _response.body,
                rawResponse: _response.rawResponse,
            };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "GET", "/workflows/catalog/harnesses/{ag_harness}");
    }
    /**
     * List workflow blueprints shipped with the product.
     *
     * Filter by domain with `is_application`, `is_evaluator`, or
     * `is_snippet`. Archived templates are hidden unless `include_archived`
     * is true. Templates are global and read-only.
     *
     * See: [Workflows](/reference/api-guide/workflows).
     *
     * @param {AgentaApi.ListWorkflowCatalogTemplatesRequest} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.workflows.listWorkflowCatalogTemplates()
     */
    listWorkflowCatalogTemplates(request = {}, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__listWorkflowCatalogTemplates(request, requestOptions));
    }
    async __listWorkflowCatalogTemplates(request = {}, requestOptions) {
        const { include_archived: includeArchived, is_application: isApplication, is_evaluator: isEvaluator, is_snippet: isSnippet, } = request;
        const _queryParams = {
            include_archived: includeArchived,
            is_application: isApplication,
            is_evaluator: isEvaluator,
            is_snippet: isSnippet,
        };
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "workflows/catalog/templates/"),
            method: "GET",
            headers: _headers,
            queryParameters: { ..._queryParams, ...requestOptions?.queryParams },
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return {
                data: _response.body,
                rawResponse: _response.rawResponse,
            };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "GET", "/workflows/catalog/templates/");
    }
    /**
     * Return a single workflow template by its key.
     *
     * Returns `count=0` when the template is not found. Templates are global
     * metadata and are not scoped to a project.
     *
     * See: [Workflows](/reference/api-guide/workflows).
     *
     * @param {AgentaApi.FetchWorkflowCatalogTemplateRequest} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.workflows.fetchWorkflowCatalogTemplate({
     *         template_key: "template_key"
     *     })
     */
    fetchWorkflowCatalogTemplate(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__fetchWorkflowCatalogTemplate(request, requestOptions));
    }
    async __fetchWorkflowCatalogTemplate(request, requestOptions) {
        const { template_key: templateKey } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `workflows/catalog/templates/${core.url.encodePathParam(templateKey)}`),
            method: "GET",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return {
                data: _response.body,
                rawResponse: _response.rawResponse,
            };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "GET", "/workflows/catalog/templates/{template_key}");
    }
    /**
     * List presets defined against a template.
     *
     * Presets are named parameter sets that can be committed as the first
     * revision of a new variant. Returns an empty list when a template has
     * no canned presets.
     *
     * See: [Workflows](/reference/api-guide/workflows).
     *
     * @param {AgentaApi.ListWorkflowCatalogPresetsRequest} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.workflows.listWorkflowCatalogPresets({
     *         template_key: "template_key"
     *     })
     */
    listWorkflowCatalogPresets(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__listWorkflowCatalogPresets(request, requestOptions));
    }
    async __listWorkflowCatalogPresets(request, requestOptions) {
        const { template_key: templateKey, include_archived: includeArchived } = request;
        const _queryParams = {
            include_archived: includeArchived,
        };
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `workflows/catalog/templates/${core.url.encodePathParam(templateKey)}/presets/`),
            method: "GET",
            headers: _headers,
            queryParameters: { ..._queryParams, ...requestOptions?.queryParams },
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return {
                data: _response.body,
                rawResponse: _response.rawResponse,
            };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "GET", "/workflows/catalog/templates/{template_key}/presets/");
    }
    /**
     * Return a single preset for a template by key.
     *
     * Returns `count=0` when the preset is not defined.
     *
     * See: [Workflows](/reference/api-guide/workflows).
     *
     * @param {AgentaApi.FetchWorkflowCatalogPresetRequest} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.workflows.fetchWorkflowCatalogPreset({
     *         template_key: "template_key",
     *         preset_key: "preset_key"
     *     })
     */
    fetchWorkflowCatalogPreset(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__fetchWorkflowCatalogPreset(request, requestOptions));
    }
    async __fetchWorkflowCatalogPreset(request, requestOptions) {
        const { template_key: templateKey, preset_key: presetKey } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `workflows/catalog/templates/${core.url.encodePathParam(templateKey)}/presets/${core.url.encodePathParam(presetKey)}`),
            method: "GET",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return {
                data: _response.body,
                rawResponse: _response.rawResponse,
            };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "GET", "/workflows/catalog/templates/{template_key}/presets/{preset_key}");
    }
    /**
     * Create a workflow artifact.
     *
     * Creates the top-level container only; commit a revision on a variant
     * before the workflow can be retrieved or invoked. Use when you need the
     * lower-level primitive — pick `/applications/` for serving logic or
     * `/evaluators/` for scoring logic.
     *
     * See: [Workflows](/reference/api-guide/workflows),
     * [Versioning](/reference/api-guide/versioning).
     *
     * @param {AgentaApi.WorkflowCreateRequest} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.workflows.createWorkflow({
     *         workflow: {}
     *     })
     */
    createWorkflow(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__createWorkflow(request, requestOptions));
    }
    async __createWorkflow(request, requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "workflows/"),
            method: "POST",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: request,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/workflows/");
    }
    /**
     * Fetch a workflow artifact by ID.
     *
     * Returns the artifact only — variants and revisions are not included.
     * Use `/workflows/variants/query` and `/workflows/revisions/query` for
     * the child entities.
     *
     * See: [Workflows](/reference/api-guide/workflows).
     *
     * @param {AgentaApi.FetchWorkflowRequest} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.workflows.fetchWorkflow({
     *         workflow_id: "workflow_id"
     *     })
     */
    fetchWorkflow(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__fetchWorkflow(request, requestOptions));
    }
    async __fetchWorkflow(request, requestOptions) {
        const { workflow_id: workflowId } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `workflows/${core.url.encodePathParam(workflowId)}`),
            method: "GET",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "GET", "/workflows/{workflow_id}");
    }
    /**
     * Update artifact-level fields on a workflow.
     *
     * The `id` in the body must match the path parameter. Only supplied
     * fields are modified. Configuration (parameters, URL, schemas) lives on
     * revisions — commit a new revision to change those.
     *
     * See: [Workflows](/reference/api-guide/workflows),
     * [Versioning](/reference/api-guide/versioning).
     *
     * @param {AgentaApi.WorkflowEditRequest} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.workflows.editWorkflow({
     *         workflow_id: "workflow_id",
     *         workflow: {}
     *     })
     */
    editWorkflow(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__editWorkflow(request, requestOptions));
    }
    async __editWorkflow(request, requestOptions) {
        const { workflow_id: workflowId, ..._body } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `workflows/${core.url.encodePathParam(workflowId)}`),
            method: "PUT",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: _body,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "PUT", "/workflows/{workflow_id}");
    }
    /**
     * Archive a workflow artifact (soft delete).
     *
     * Sets `deleted_at` on the workflow and its variants. Archived
     * workflows are hidden from queries unless `include_archived=true`.
     * Revision IDs remain resolvable so historical traces stay intact.
     *
     * See: [Versioning](/reference/api-guide/versioning).
     *
     * @param {AgentaApi.ArchiveWorkflowRequest} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.workflows.archiveWorkflow({
     *         workflow_id: "workflow_id"
     *     })
     */
    archiveWorkflow(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__archiveWorkflow(request, requestOptions));
    }
    async __archiveWorkflow(request, requestOptions) {
        const { workflow_id: workflowId } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `workflows/${core.url.encodePathParam(workflowId)}/archive`),
            method: "POST",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/workflows/{workflow_id}/archive");
    }
    /**
     * Restore a previously archived workflow.
     *
     * Clears `deleted_at` on the workflow. Archived variants and revisions
     * are restored with the workflow.
     *
     * See: [Versioning](/reference/api-guide/versioning).
     *
     * @param {AgentaApi.UnarchiveWorkflowRequest} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.workflows.unarchiveWorkflow({
     *         workflow_id: "workflow_id"
     *     })
     */
    unarchiveWorkflow(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__unarchiveWorkflow(request, requestOptions));
    }
    async __unarchiveWorkflow(request, requestOptions) {
        const { workflow_id: workflowId } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `workflows/${core.url.encodePathParam(workflowId)}/unarchive`),
            method: "POST",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/workflows/{workflow_id}/unarchive");
    }
    /**
     * Query workflow artifacts with filters and pagination.
     *
     * Accepts the same filters as query parameters or in the request body;
     * body fields win when both are supplied. Results are ordered by
     * creation time; pass `windowing.next` back for the following page.
     *
     * See: [Query Pattern](/reference/api-guide/query-pattern).
     *
     * @param {AgentaApi.QueryWorkflowsRequest} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.workflows.queryWorkflows()
     */
    queryWorkflows(request = {}, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__queryWorkflows(request, requestOptions));
    }
    async __queryWorkflows(request = {}, requestOptions) {
        const { workflow_id: workflowId, workflow_ids: workflowIds, workflow_slug: workflowSlug, workflow_slugs: workflowSlugs, name, description, flags, tags, meta, include_archived: includeArchived, next, newest, oldest, limit, order, } = request;
        const _queryParams = {
            workflow_id: workflowId,
            workflow_ids: workflowIds !== undefined ? toJson(workflowIds) : undefined,
            workflow_slug: workflowSlug,
            workflow_slugs: workflowSlugs !== undefined ? toJson(workflowSlugs) : undefined,
            name,
            description,
            flags,
            tags,
            meta,
            include_archived: includeArchived,
            next,
            newest: newest !== undefined ? newest : undefined,
            oldest: oldest !== undefined ? oldest : undefined,
            limit,
            order: order !== undefined ? order : undefined,
        };
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "workflows/query"),
            method: "POST",
            headers: _headers,
            queryParameters: { ..._queryParams, ...requestOptions?.queryParams },
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/workflows/query");
    }
    /**
     * Create a new variant under an existing workflow.
     *
     * Variants are branches of an artifact's history; each maintains its own
     * revision log. Variant slugs are unique within the project — reuse of a
     * slug already in use returns a 409 conflict.
     *
     * See: [Versioning](/reference/api-guide/versioning).
     *
     * @param {AgentaApi.WorkflowVariantCreateRequest} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.workflows.createWorkflowVariant({
     *         workflow_variant: {}
     *     })
     */
    createWorkflowVariant(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__createWorkflowVariant(request, requestOptions));
    }
    async __createWorkflowVariant(request, requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "workflows/variants/"),
            method: "POST",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: request,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/workflows/variants/");
    }
    /**
     * Fetch a workflow variant by ID.
     *
     * Returns the variant metadata only — use
     * `/workflows/revisions/retrieve` or `/workflows/revisions/log` for the
     * variant's revisions.
     *
     * See: [Workflows](/reference/api-guide/workflows).
     *
     * @param {AgentaApi.FetchWorkflowVariantRequest} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.workflows.fetchWorkflowVariant({
     *         workflow_variant_id: "workflow_variant_id"
     *     })
     */
    fetchWorkflowVariant(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__fetchWorkflowVariant(request, requestOptions));
    }
    async __fetchWorkflowVariant(request, requestOptions) {
        const { workflow_variant_id: workflowVariantId } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `workflows/variants/${core.url.encodePathParam(workflowVariantId)}`),
            method: "GET",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "GET", "/workflows/variants/{workflow_variant_id}");
    }
    /**
     * Update metadata on a workflow variant.
     *
     * The `id` in the body must match the path parameter. Revisions on the
     * variant are not affected — commit a new revision to change data.
     *
     * See: [Versioning](/reference/api-guide/versioning).
     *
     * @param {AgentaApi.WorkflowVariantEditRequest} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.workflows.editWorkflowVariant({
     *         workflow_variant_id: "workflow_variant_id",
     *         workflow_variant: {}
     *     })
     */
    editWorkflowVariant(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__editWorkflowVariant(request, requestOptions));
    }
    async __editWorkflowVariant(request, requestOptions) {
        const { workflow_variant_id: workflowVariantId, ..._body } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `workflows/variants/${core.url.encodePathParam(workflowVariantId)}`),
            method: "PUT",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: _body,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "PUT", "/workflows/variants/{workflow_variant_id}");
    }
    /**
     * Archive a workflow variant.
     *
     * Soft-deletes the variant and its revisions. Archived variants are
     * hidden from queries unless `include_archived=true`. See
     * [Versioning](/reference/api-guide/versioning).
     *
     * @param {AgentaApi.ArchiveWorkflowVariantRequest} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.workflows.archiveWorkflowVariant({
     *         workflow_variant_id: "workflow_variant_id"
     *     })
     */
    archiveWorkflowVariant(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__archiveWorkflowVariant(request, requestOptions));
    }
    async __archiveWorkflowVariant(request, requestOptions) {
        const { workflow_variant_id: workflowVariantId } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `workflows/variants/${core.url.encodePathParam(workflowVariantId)}/archive`),
            method: "POST",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/workflows/variants/{workflow_variant_id}/archive");
    }
    /**
     * Restore a previously archived workflow variant.
     *
     * Clears `deleted_at` on the variant and its revisions. See
     * [Versioning](/reference/api-guide/versioning).
     *
     * @param {AgentaApi.UnarchiveWorkflowVariantRequest} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.workflows.unarchiveWorkflowVariant({
     *         workflow_variant_id: "workflow_variant_id"
     *     })
     */
    unarchiveWorkflowVariant(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__unarchiveWorkflowVariant(request, requestOptions));
    }
    async __unarchiveWorkflowVariant(request, requestOptions) {
        const { workflow_variant_id: workflowVariantId } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `workflows/variants/${core.url.encodePathParam(workflowVariantId)}/unarchive`),
            method: "POST",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/workflows/variants/{workflow_variant_id}/unarchive");
    }
    /**
     * Query workflow variants with filters and pagination.
     *
     * Scope the query by `workflow_refs` (parent artifact) or
     * `workflow_variant_refs` (specific variants). Accepts the same fields
     * as query parameters or in the request body.
     *
     * See: [Query Pattern](/reference/api-guide/query-pattern).
     *
     * @param {AgentaApi.QueryWorkflowVariantsRequest} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.workflows.queryWorkflowVariants()
     */
    queryWorkflowVariants(request = {}, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__queryWorkflowVariants(request, requestOptions));
    }
    async __queryWorkflowVariants(request = {}, requestOptions) {
        const { workflow_id: workflowId, workflow_ids: workflowIds, workflow_slug: workflowSlug, workflow_slugs: workflowSlugs, workflow_variant_id: workflowVariantId, workflow_variant_ids: workflowVariantIds, workflow_variant_slug: workflowVariantSlug, workflow_variant_slugs: workflowVariantSlugs, name, description, flags, tags, meta, include_archived: includeArchived, next, newest, oldest, limit, order, } = request;
        const _queryParams = {
            workflow_id: workflowId,
            workflow_ids: workflowIds !== undefined ? toJson(workflowIds) : undefined,
            workflow_slug: workflowSlug,
            workflow_slugs: workflowSlugs !== undefined ? toJson(workflowSlugs) : undefined,
            workflow_variant_id: workflowVariantId,
            workflow_variant_ids: workflowVariantIds !== undefined ? toJson(workflowVariantIds) : undefined,
            workflow_variant_slug: workflowVariantSlug,
            workflow_variant_slugs: workflowVariantSlugs !== undefined ? toJson(workflowVariantSlugs) : undefined,
            name,
            description,
            flags,
            tags,
            meta,
            include_archived: includeArchived,
            next,
            newest: newest !== undefined ? newest : undefined,
            oldest: oldest !== undefined ? oldest : undefined,
            limit,
            order: order !== undefined ? order : undefined,
        };
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "workflows/variants/query"),
            method: "POST",
            headers: _headers,
            queryParameters: { ..._queryParams, ...requestOptions?.queryParams },
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/workflows/variants/query");
    }
    /**
     * @param {AgentaApi.WorkflowVariantForkRequest} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.workflows.forkWorkflowVariant({
     *         workflow_variant: {},
     *         workflow_variant_ref: {}
     *     })
     */
    forkWorkflowVariant(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__forkWorkflowVariant(request, requestOptions));
    }
    async __forkWorkflowVariant(request, requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "workflows/variants/fork"),
            method: "POST",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: request,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/workflows/variants/fork");
    }
    /**
     * @param {AgentaApi.WorkflowRevisionRetrieveRequest} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.workflows.retrieveWorkflowRevision()
     */
    retrieveWorkflowRevision(request = {}, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__retrieveWorkflowRevision(request, requestOptions));
    }
    async __retrieveWorkflowRevision(request = {}, requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "workflows/revisions/retrieve"),
            method: "POST",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: request,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/workflows/revisions/retrieve");
    }
    /**
     * @param {AgentaApi.WorkflowRevisionDeployRequest} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.workflows.deployWorkflowRevision()
     */
    deployWorkflowRevision(request = {}, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__deployWorkflowRevision(request, requestOptions));
    }
    async __deployWorkflowRevision(request = {}, requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "workflows/revisions/deploy"),
            method: "POST",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: request,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/workflows/revisions/deploy");
    }
    /**
     * @param {AgentaApi.WorkflowRevisionCreateRequest} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.workflows.createWorkflowRevision({
     *         workflow_revision: {}
     *     })
     */
    createWorkflowRevision(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__createWorkflowRevision(request, requestOptions));
    }
    async __createWorkflowRevision(request, requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "workflows/revisions/"),
            method: "POST",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: request,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/workflows/revisions/");
    }
    /**
     * @param {AgentaApi.FetchWorkflowRevisionRequest} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.workflows.fetchWorkflowRevision({
     *         workflow_revision_id: "workflow_revision_id"
     *     })
     */
    fetchWorkflowRevision(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__fetchWorkflowRevision(request, requestOptions));
    }
    async __fetchWorkflowRevision(request, requestOptions) {
        const { workflow_revision_id: workflowRevisionId } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `workflows/revisions/${core.url.encodePathParam(workflowRevisionId)}`),
            method: "GET",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "GET", "/workflows/revisions/{workflow_revision_id}");
    }
    /**
     * @param {AgentaApi.WorkflowRevisionEditRequest} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.workflows.editWorkflowRevision({
     *         workflow_revision_id: "workflow_revision_id",
     *         workflow_revision: {}
     *     })
     */
    editWorkflowRevision(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__editWorkflowRevision(request, requestOptions));
    }
    async __editWorkflowRevision(request, requestOptions) {
        const { workflow_revision_id: workflowRevisionId, ..._body } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `workflows/revisions/${core.url.encodePathParam(workflowRevisionId)}`),
            method: "PUT",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: _body,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "PUT", "/workflows/revisions/{workflow_revision_id}");
    }
    /**
     * @param {AgentaApi.ArchiveWorkflowRevisionRequest} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.workflows.archiveWorkflowRevision({
     *         workflow_revision_id: "workflow_revision_id"
     *     })
     */
    archiveWorkflowRevision(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__archiveWorkflowRevision(request, requestOptions));
    }
    async __archiveWorkflowRevision(request, requestOptions) {
        const { workflow_revision_id: workflowRevisionId } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `workflows/revisions/${core.url.encodePathParam(workflowRevisionId)}/archive`),
            method: "POST",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/workflows/revisions/{workflow_revision_id}/archive");
    }
    /**
     * @param {AgentaApi.UnarchiveWorkflowRevisionRequest} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.workflows.unarchiveWorkflowRevision({
     *         workflow_revision_id: "workflow_revision_id"
     *     })
     */
    unarchiveWorkflowRevision(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__unarchiveWorkflowRevision(request, requestOptions));
    }
    async __unarchiveWorkflowRevision(request, requestOptions) {
        const { workflow_revision_id: workflowRevisionId } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `workflows/revisions/${core.url.encodePathParam(workflowRevisionId)}/unarchive`),
            method: "POST",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/workflows/revisions/{workflow_revision_id}/unarchive");
    }
    /**
     * @param {AgentaApi.QueryWorkflowRevisionsRequest} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.workflows.queryWorkflowRevisions({
     *         body: {}
     *     })
     */
    queryWorkflowRevisions(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__queryWorkflowRevisions(request, requestOptions));
    }
    async __queryWorkflowRevisions(request, requestOptions) {
        const { workflow_id: workflowId, workflow_ids: workflowIds, workflow_slug: workflowSlug, workflow_slugs: workflowSlugs, workflow_variant_id: workflowVariantId, workflow_variant_ids: workflowVariantIds, workflow_variant_slug: workflowVariantSlug, workflow_variant_slugs: workflowVariantSlugs, workflow_revision_id: workflowRevisionId, workflow_revision_ids: workflowRevisionIds, workflow_revision_slug: workflowRevisionSlug, workflow_revision_slugs: workflowRevisionSlugs, workflow_revision_version: workflowRevisionVersion, workflow_revision_versions: workflowRevisionVersions, name, description, flags, tags, meta, include_archived: includeArchived, next, newest, oldest, limit, order, body: _body, } = request;
        const _queryParams = {
            workflow_id: workflowId,
            workflow_ids: workflowIds !== undefined ? toJson(workflowIds) : undefined,
            workflow_slug: workflowSlug,
            workflow_slugs: workflowSlugs !== undefined ? toJson(workflowSlugs) : undefined,
            workflow_variant_id: workflowVariantId,
            workflow_variant_ids: workflowVariantIds !== undefined ? toJson(workflowVariantIds) : undefined,
            workflow_variant_slug: workflowVariantSlug,
            workflow_variant_slugs: workflowVariantSlugs !== undefined ? toJson(workflowVariantSlugs) : undefined,
            workflow_revision_id: workflowRevisionId,
            workflow_revision_ids: workflowRevisionIds !== undefined ? toJson(workflowRevisionIds) : undefined,
            workflow_revision_slug: workflowRevisionSlug,
            workflow_revision_slugs: workflowRevisionSlugs !== undefined ? toJson(workflowRevisionSlugs) : undefined,
            workflow_revision_version: workflowRevisionVersion,
            workflow_revision_versions: workflowRevisionVersions !== undefined ? toJson(workflowRevisionVersions) : undefined,
            name,
            description,
            flags,
            tags,
            meta,
            include_archived: includeArchived,
            next,
            newest: newest !== undefined ? newest : undefined,
            oldest: oldest !== undefined ? oldest : undefined,
            limit,
            order: order !== undefined ? order : undefined,
        };
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "workflows/revisions/query"),
            method: "POST",
            headers: _headers,
            contentType: "application/json",
            queryParameters: { ..._queryParams, ...requestOptions?.queryParams },
            requestType: "json",
            body: _body,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/workflows/revisions/query");
    }
    /**
     * The human and SDK route: no write scope, the caller owns the whole revision.
     *
     * @param {AgentaApi.WorkflowRevisionCommitRequest} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.workflows.commitWorkflowRevision({
     *         workflow_revision: {}
     *     })
     */
    commitWorkflowRevision(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__commitWorkflowRevision(request, requestOptions));
    }
    async __commitWorkflowRevision(request, requestOptions) {
        const { workflow_variant_id: workflowVariantId, ..._body } = request;
        const _queryParams = {
            workflow_variant_id: workflowVariantId,
        };
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "workflows/revisions/commit"),
            method: "POST",
            headers: _headers,
            contentType: "application/json",
            queryParameters: { ..._queryParams, ...requestOptions?.queryParams },
            requestType: "json",
            body: _body,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/workflows/revisions/commit");
    }
    /**
     * @param {AgentaApi.WorkflowRevisionsLogRequest} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.workflows.logWorkflowRevisions({
     *         workflow_revisions: {}
     *     })
     */
    logWorkflowRevisions(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__logWorkflowRevisions(request, requestOptions));
    }
    async __logWorkflowRevisions(request, requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "workflows/revisions/log"),
            method: "POST",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: request,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/workflows/revisions/log");
    }
    /**
     * Resolve embedded references in a workflow revision configuration.
     *
     * This endpoint:
     * 1. Fetches the workflow revision
     * 2. Resolves all @ag.references tokens in the configuration
     * 3. Returns the revision with resolved configuration + metadata
     *
     * @param {AgentaApi.WorkflowRevisionResolveRequest} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.workflows.resolveWorkflowRevision()
     */
    resolveWorkflowRevision(request = {}, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__resolveWorkflowRevision(request, requestOptions));
    }
    async __resolveWorkflowRevision(request = {}, requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "workflows/revisions/resolve"),
            method: "POST",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: request,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return {
                data: _response.body,
                rawResponse: _response.rawResponse,
            };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/workflows/revisions/resolve");
    }
    /**
     * @param {AgentaApi.TemplateValidateRequest} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.ForbiddenError}
     * @throws {@link AgentaApi.NotFoundError}
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.workflows.validateAgentTemplate({
     *         source: {
     *             kind: "internal",
     *             key: "key",
     *             kind: "internal"
     *         }
     *     })
     */
    validateAgentTemplate(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__validateAgentTemplate(request, requestOptions));
    }
    async __validateAgentTemplate(request, requestOptions) {
        const { project_id: projectId, ..._body } = request;
        const _queryParams = {
            project_id: projectId,
        };
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "agent-templates/validate"),
            method: "POST",
            headers: _headers,
            contentType: "application/json",
            queryParameters: { ..._queryParams, ...requestOptions?.queryParams },
            requestType: "json",
            body: _body,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 403:
                    throw new AgentaApi.ForbiddenError(_response.error.body, _response.rawResponse);
                case 404:
                    throw new AgentaApi.NotFoundError(_response.error.body, _response.rawResponse);
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/agent-templates/validate");
    }
    /**
     * @param {AgentaApi.TemplatesQueryRequest | null} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.workflows.queryAgentTemplates({})
     */
    queryAgentTemplates(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__queryAgentTemplates(request, requestOptions));
    }
    async __queryAgentTemplates(request, requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "agent-templates/query"),
            method: "POST",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: request,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/agent-templates/query");
    }
    /**
     * @param {AgentaApi.TemplateSourceScanRequest} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.ForbiddenError}
     * @throws {@link AgentaApi.NotFoundError}
     * @throws {@link AgentaApi.UnprocessableEntityError}
     * @throws {@link AgentaApi.ServiceUnavailableError}
     *
     * @example
     *     await client.workflows.scanAgentTemplateSource({
     *         repo_url: "repo_url"
     *     })
     */
    scanAgentTemplateSource(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__scanAgentTemplateSource(request, requestOptions));
    }
    async __scanAgentTemplateSource(request, requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "agent-templates/sources/scan"),
            method: "POST",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: request,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 403:
                    throw new AgentaApi.ForbiddenError(_response.error.body, _response.rawResponse);
                case 404:
                    throw new AgentaApi.NotFoundError(_response.error.body, _response.rawResponse);
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                case 503:
                    throw new AgentaApi.ServiceUnavailableError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/agent-templates/sources/scan");
    }
    /**
     * @param {AgentaApi.TemplateLoadRequest} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.BadRequestError}
     * @throws {@link AgentaApi.ForbiddenError}
     * @throws {@link AgentaApi.NotFoundError}
     * @throws {@link AgentaApi.ConflictError}
     * @throws {@link AgentaApi.UnprocessableEntityError}
     * @throws {@link AgentaApi.ServiceUnavailableError}
     *
     * @example
     *     await client.workflows.loadAgentTemplate({
     *         project_id: "project_id",
     *         source: {
     *             kind: "internal",
     *             key: "key",
     *             kind: "internal"
     *         },
     *         base_revision: {},
     *         initial_message: "initial_message"
     *     })
     */
    loadAgentTemplate(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__loadAgentTemplate(request, requestOptions));
    }
    async __loadAgentTemplate(request, requestOptions) {
        const { project_id: projectId, ..._body } = request;
        const _queryParams = {
            project_id: projectId,
        };
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "agent-templates/load"),
            method: "POST",
            headers: _headers,
            contentType: "application/json",
            queryParameters: { ..._queryParams, ...requestOptions?.queryParams },
            requestType: "json",
            body: _body,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 400:
                    throw new AgentaApi.BadRequestError(_response.error.body, _response.rawResponse);
                case 403:
                    throw new AgentaApi.ForbiddenError(_response.error.body, _response.rawResponse);
                case 404:
                    throw new AgentaApi.NotFoundError(_response.error.body, _response.rawResponse);
                case 409:
                    throw new AgentaApi.ConflictError(_response.error.body, _response.rawResponse);
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                case 503:
                    throw new AgentaApi.ServiceUnavailableError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/agent-templates/load");
    }
    /**
     * @param {AgentaApi.FetchAgentTemplateRequest} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.NotFoundError}
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.workflows.fetchAgentTemplate({
     *         key: "key"
     *     })
     */
    fetchAgentTemplate(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__fetchAgentTemplate(request, requestOptions));
    }
    async __fetchAgentTemplate(request, requestOptions) {
        const { key, version } = request;
        const _queryParams = {
            version,
        };
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `agent-templates/${core.url.encodePathParam(key)}`),
            method: "GET",
            headers: _headers,
            queryParameters: { ..._queryParams, ...requestOptions?.queryParams },
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 404:
                    throw new AgentaApi.NotFoundError(_response.error.body, _response.rawResponse);
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "GET", "/agent-templates/{key}");
    }
    /**
     * @param {AgentaApi.SimpleWorkflowCreateRequest} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.workflows.createSimpleWorkflow({
     *         workflow: {}
     *     })
     */
    createSimpleWorkflow(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__createSimpleWorkflow(request, requestOptions));
    }
    async __createSimpleWorkflow(request, requestOptions) {
        const { workflow_id: workflowId, ..._body } = request;
        const _queryParams = {
            workflow_id: workflowId,
        };
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "simple/workflows/"),
            method: "POST",
            headers: _headers,
            contentType: "application/json",
            queryParameters: { ..._queryParams, ...requestOptions?.queryParams },
            requestType: "json",
            body: _body,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/simple/workflows/");
    }
    /**
     * @param {AgentaApi.FetchSimpleWorkflowRequest} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.workflows.fetchSimpleWorkflow({
     *         workflow_id: "workflow_id"
     *     })
     */
    fetchSimpleWorkflow(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__fetchSimpleWorkflow(request, requestOptions));
    }
    async __fetchSimpleWorkflow(request, requestOptions) {
        const { workflow_id: workflowId } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `simple/workflows/${core.url.encodePathParam(workflowId)}`),
            method: "GET",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "GET", "/simple/workflows/{workflow_id}");
    }
    /**
     * @param {AgentaApi.SimpleWorkflowEditRequest} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.workflows.editSimpleWorkflow({
     *         workflow_id: "workflow_id",
     *         workflow: {}
     *     })
     */
    editSimpleWorkflow(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__editSimpleWorkflow(request, requestOptions));
    }
    async __editSimpleWorkflow(request, requestOptions) {
        const { workflow_id: workflowId, ..._body } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `simple/workflows/${core.url.encodePathParam(workflowId)}`),
            method: "PUT",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: _body,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "PUT", "/simple/workflows/{workflow_id}");
    }
    /**
     * @param {AgentaApi.ArchiveSimpleWorkflowRequest} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.workflows.archiveSimpleWorkflow({
     *         workflow_id: "workflow_id"
     *     })
     */
    archiveSimpleWorkflow(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__archiveSimpleWorkflow(request, requestOptions));
    }
    async __archiveSimpleWorkflow(request, requestOptions) {
        const { workflow_id: workflowId } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `simple/workflows/${core.url.encodePathParam(workflowId)}/archive`),
            method: "POST",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/simple/workflows/{workflow_id}/archive");
    }
    /**
     * @param {AgentaApi.UnarchiveSimpleWorkflowRequest} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.workflows.unarchiveSimpleWorkflow({
     *         workflow_id: "workflow_id"
     *     })
     */
    unarchiveSimpleWorkflow(request, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__unarchiveSimpleWorkflow(request, requestOptions));
    }
    async __unarchiveSimpleWorkflow(request, requestOptions) {
        const { workflow_id: workflowId } = request;
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, `simple/workflows/${core.url.encodePathParam(workflowId)}/unarchive`),
            method: "POST",
            headers: _headers,
            queryParameters: requestOptions?.queryParams,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/simple/workflows/{workflow_id}/unarchive");
    }
    /**
     * @param {AgentaApi.SimpleWorkflowQueryRequest} request
     * @param {WorkflowsClient.RequestOptions} requestOptions - Request-specific configuration.
     *
     * @throws {@link AgentaApi.UnprocessableEntityError}
     *
     * @example
     *     await client.workflows.querySimpleWorkflows()
     */
    querySimpleWorkflows(request = {}, requestOptions) {
        return core.HttpResponsePromise.fromPromise(this.__querySimpleWorkflows(request, requestOptions));
    }
    async __querySimpleWorkflows(request = {}, requestOptions) {
        const _authRequest = await this._options.authProvider.getAuthRequest();
        const _headers = mergeHeaders(_authRequest.headers, this._options?.headers, requestOptions?.headers);
        const _response = await core.fetcher({
            url: core.url.join((await core.Supplier.get(this._options.baseUrl)) ??
                (await core.Supplier.get(this._options.environment)) ??
                environments.AgentaApiEnvironment.Default, "simple/workflows/query"),
            method: "POST",
            headers: _headers,
            contentType: "application/json",
            queryParameters: requestOptions?.queryParams,
            requestType: "json",
            body: request,
            timeoutMs: (requestOptions?.timeoutInSeconds ?? this._options?.timeoutInSeconds ?? 30) * 1000,
            maxRetries: requestOptions?.maxRetries ?? this._options?.maxRetries,
            withCredentials: true,
            abortSignal: requestOptions?.abortSignal,
            fetchFn: this._options?.fetch,
            logging: this._options.logging,
        });
        if (_response.ok) {
            return { data: _response.body, rawResponse: _response.rawResponse };
        }
        if (_response.error.reason === "status-code") {
            switch (_response.error.statusCode) {
                case 422:
                    throw new AgentaApi.UnprocessableEntityError(_response.error.body, _response.rawResponse);
                default:
                    throw new errors.AgentaApiError({
                        statusCode: _response.error.statusCode,
                        body: _response.error.body,
                        rawResponse: _response.rawResponse,
                    });
            }
        }
        return handleNonStatusCodeError(_response.error, _response.rawResponse, "POST", "/simple/workflows/query");
    }
}
